/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureAppIdResponse {
  /**
  * The application ID
  */
  'applicationId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureAppIdResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

